import { Button } from '@/kit/Button';
import { Icon } from '@/kit/Icon';
import { DialogClose, DialogContent, type DialogComponentProps } from '@/kit/dialog';

/**
 * APT335: a reporting code on the other side of an account's nature (an expense mapped to an income code) is allowed only when the user has seen
 * it and confirms. Closes with true on "Save anyway"; the caller treats only exactly true as confirmed.
 */
export function MappingWarningsDialog({ data, dialogRef }: DialogComponentProps<{ messages: string[] }, boolean>) {
  const messages = data?.messages ?? [];
  return (
    <div className="mat-dialog-wrapper new-account">
      <DialogContent>
        <form onSubmit={(event) => event.preventDefault()}>
          <div className="main-contain">
            <div className="sidenav-header">
              <div className="d-flex align-items-center justify-space-between">
                <h2 className="m-0">
                  <span>Please confirm</span>
                </h2>
                <DialogClose>
                  <Icon name="close" className="close" />
                </DialogClose>
              </div>
            </div>
          </div>
          <div className="sidenav-body">
            <p className="pt-1">
              {messages.length === 1 ? 'This mapping looks unusual:' : `${messages.length} mappings look unusual:`}
            </p>
            <ul className="mapping-warning-list">
              {messages.map((message, index) => (
                <li key={index}>{message}</li>
              ))}
            </ul>
            <p className="pb-2">Save them anyway?</p>
          </div>

          <div className="d-flex gap-15 hr-top pt-1 mt-1">
            <Button className="action-button primary-button" type="button" onClick={() => dialogRef.close(true)}>
              Save anyway
            </Button>
            <DialogClose as="button" type="button" className="action-button secondary-button">
              Cancel
            </DialogClose>
          </div>
        </form>
      </DialogContent>
    </div>
  );
}
